<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-tabs [(ttSelectedId)]="selectedBgSubscriptionsMain">
            <tt-tab ttId="SUMPRSUB" ttLabel="gb_subscriptions_main_sumprsub"></tt-tab>
            <tt-tab ttId="SUBGRID" ttLabel="gb_subscriptions_main_subgrid"></tt-tab>
        </tt-tabs>

        <tt-input [hidden]="selectedBgSubscriptionsMain !== 'SUMPRSUB'" ttRememberId="w_subscriptions.filtervalue" ttLabel="filtervalue" ttFocus="false" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
    </tt-card>

    <tt-list-legacy [hidden]="selectedBgSubscriptionsMain !== 'SUMPRSUB'" class="col-xs-12 col-md-12 p-5" [listItems]="itemsListSubscriptions" ltype="multi" typevar="g" [filterVal]="setting.filtervalue"></tt-list-legacy>
    <tt-grid [hidden]="selectedBgSubscriptionsMain !== 'SUBGRID'" *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
